import React from 'react';

export const useInteractOutside = <ElementType,>(
	onInteractOutside: (event: FocusEvent) => void,
) => {
	const componentRef = React.useRef<ElementType>(null);

	React.useEffect(() => {
		const onInteract = (event: FocusEvent) => {
			if (!componentRef.current) return;

			if (
				(componentRef.current as unknown as Node).contains(event.target as Node)
			)
				return;

			onInteractOutside(event);
		};
		document.addEventListener('focusin', onInteract);
		document.addEventListener('click', onInteract);

		return () => {
			document.removeEventListener('focusin', onInteract);
			document.removeEventListener('click', onInteract);
		};
	}, [onInteractOutside]);

	return {
		ref: componentRef,
		// So focus doesn't go outside when clicking inside
		tabIndex: -1,
	};
};
